const defaultFormValues = {
  background_color: {
    hex: '',
    image: '',
    cmyk: {
      c: '',
      m: '',
      y: '',
      k: ''
    }
  },
  stickers: [],
  texts: [],
  photos: [],
  empty_texts: []
}

export type TSticker = {
  id: string
  name_en: string
  name_th: string | null
  order: string
  sticker_image_url: string
  thumbnail_sticker_image_url: string
}

export type CustomPersonalizationStateV2 = {
  templateMetadata: {
    backgroundColor?: {
      background_image_url: string | null
      color: string
      id: string
      name: string
      order: number
      rotation: number
      sku: string | null
      thumbnail_background_image_url: string | null
      type: string
    }[]
    sticker?: {
      group_label_image_url: string
      name_en: string
      name_th: string
      sku: string
      id: string
      order: string
      list: TSticker[]
    }[]
    text?: {
      color: {
        id: string
        name: string
        color: string
        rotation: number
        order: number
      }[]
      fontFamily: {
        id: string
        name: string
        font_file_url: string
        thumbnail_image_url: string | null
        sku: string | null
        order: number
      }[]
      position: {
        id: string
        name: string
        metadata: string | null
        thumbnail_image_url: string | null
        order: number
      }[]
      size: {
        id: string
        name: string
        size: number
        thumbnail_image_url: string | null
        order: number
      }[]
    }
  }
  metadata: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    history: any[]
    background_color: {
      hex: string
      image: string
      cmyk: {
        c: string
        m: string
        y: string
        k: string
      }
    }
    stickers: {
      id: string
      x: number
      y: number
      width: number
      height: number
      image: string
      rotation: number
    }[]
    focused_text?: {
      id: string
    }
    texts: {
      id: string
      x: number
      y: number
      width?: number
      height?: number
      text: string
      rotation: number
      color: string
      font_type: string
      font_size: number
      custom_color: string
      position_type: string
    }[]
    empty_texts: {
      id: string
      x: number
      y: number
      width?: number
      height?: number
      text: string
      rotation: number
      color: string
      font_type: string
      font_size: number
      custom_color: string
      position_type: string
    }[]
    photos: {
      id: string
      x: number
      y: number
      width: number
      height: number
      type: string
      url: string
      aspectRatio: number
    }[]
    text_custom_change_count: number
    history_index: number
    isReadyAddSticker: boolean
    case_type?: {
      name_en: string
      name_th: string
      slug: string
      price: string
      product_variant_detail_id: string
    }
    shared_url: string
    device_groups_selected: { iPhone: string; Samsung: string }
    device_selected?: {
      name_en: string
      name_th: string
      slug: string
      category: string
      device_image: string
      case_image: string
    }
    case_color: { value: string; name_en: string; name_th: string }
    active_menu: string
    thumbnail_base64: string
  }
}

const initialState = {
  history: [{ ...defaultFormValues }],
  text_custom_change_count: 0,
  history_index: 0,
  isReadyAddSticker: true,
  case_type: undefined,
  device_groups_selected: { iPhone: '', Samsung: '' },
  device_selected: undefined,
  case_color: { value: '', name_en: '', name_th: '' },
  active_menu: '',
  thumbnail_base64: '',
  shared_url: '',
  ...defaultFormValues
}

export const useCustomPersonalizationStoreV2 = defineStore(
  'customPersonalizationStoreV2',
  {
    state: (): CustomPersonalizationStateV2 => ({
      metadata: { ...initialState },
      templateMetadata: {}
    }),
    actions: {
      updateMetadata(
        nextMetadata: Partial<CustomPersonalizationStateV2['metadata']>
      ) {
        this.metadata = { ...this.metadata, ...nextMetadata }
      },
      reset() {
        this.metadata = { ...initialState }
      },
      updateTemplateMetadata(
        nextMetadata: Partial<CustomPersonalizationStateV2['templateMetadata']>
      ) {
        this.templateMetadata = { ...this.templateMetadata, ...nextMetadata }
      },
      deleteTemplateMetadata() {
        this.templateMetadata = {}
      },
      toggleReady(status: boolean) {
        this.metadata.isReadyAddSticker = status
      }
    },
    persist: {
      storage: persistedState.localStorage
    }
  }
)
